<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-6">
          <h4 class="mb-0">تاریخچه اجرای قالب "{{ Context?.PM_Title || '-' }}" برای کد تجهیز "{{ Context?.codeBEHFA ||
            '-' }}"</h4>
        </div>
        <div class="col-sm-6 text-left">
          <button type="button" style="margin-left: 5px;" class="btn btn-warning ml-2" (click)="Back()">بازگشت</button>
        </div>
        <div *ngIf="Message" class="alert alert-info">{{ Message }}</div>
        <div *ngIf="Procssing" class="text-center p-3">در حال دریافت اطلاعات...</div>


      </div>
      <div *ngIf="!Procssing">
        <div class="table-responsive">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>سررسید</th>
                <th>تاریخ اجرا</th>
                <th>نتیجه</th>
                <th>مقدار عددی</th>
                <th>مقدار متنی</th>
                <th>توضیح</th>
                <th>انجام‌دهنده</th>
                <th>تأییدکننده</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of DataList| paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: DataList.length
                      }; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.Date_Due ? (item.Date_Due | date:'yyyy/MM/dd') : '-' }}</td>
                <td>{{ item.Date_Execution_Persian || '-' }}</td>
                <td>
                  <span class="badge"
                    [ngClass]="item.Result === 'Pass' ? 'badge-success' : (item.Result === 'Fail' ? 'badge-danger' : 'badge-secondary')">
                    {{ item.Result }}
                  </span>
                </td>
                <td>{{ item.Numeric_Value == null ? '-' : item.Numeric_Value }}</td>
                <td>{{ item.Text_Value || '-' }}</td>
                <td>{{ item.Comment || '-' }}</td>
                <td>{{ item.Performed_By == null ? '-' : item.Performed_By }}</td>
                <td>{{ item.Approved_By == null ? '-' : item.Approved_By }}</td>
              </tr>

              <tr *ngIf="DataList.length === 0">
                <td colspan="10" class="text-center">سابقه‌ای ثبت نشده است.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
      </pagination-controls>
    </div>
  </div>
</div>